<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize"> {{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->


            <form @submit.prevent="addNew" enctype="multipart/form-data" class="h-100">

                <!-- Content -->
                <div class="tab-content">
                    <div class="row">


                <!-- ******* Cards ******* -->
                <div class="col-md-8 mb-5">


                    <!-- Card Hotel -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabHotel" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Hotel')"
                                        aria-expanded="false"
                                        aria-controls="collapseHotel"
                                        data-toggle="collapse"
                                        data-target="#collapseHotel">Hotel
                                        <span id="iconToggleHotel"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseHotel"
                                    class="collapse show"
                                    aria-labelledby="TabHotel"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- Title -->
                                        <div class="form-group">
                                            <label for="inputText1">Title</label>
                                            <input class="form-control"
                                                    id="inputText1"
                                                    type="text"
                                                    v-model="row.title">
                                        </div>
                                        <!-- End Title -->

                                        <!-- Slug -->
                                        <div class="form-group">
                                            <label for="inputText2">Slug</label>
                                            <input class="form-control"
                                                    id="inputText2"
                                                    type="text"
                                                    v-model="row.slug"
                                                    @keydown.space.prevent>
                                        </div>
                                        <!-- End Slug -->

                                                                                <!-- Link -->
                                        <div class="form-group">
                                            <label for="inputText3">Link</label>
                                            <input class="form-control"
                                                    id="inputText3"
                                                    type="text"
                                                    v-model="row.link">
                                        </div>
                                        <!-- End Link -->


                                        <div class="row">
                                            <!-- Sort -->
                                            <div class="form-group col-6">
                                                <label for="inputText4">Sort</label>
                                                <input class="form-control"
                                                        id="inputTex4"
                                                        type="number"
                                                        min="0"
                                                        v-model.number="row.sort">
                                            </div>
                                            <!-- End Stars -->

                                            <!-- Stars -->
                                            <div class="form-group col-6">
                                                <label for="inputText5">Stars</label>
                                                <input class="form-control"
                                                        id="inputTex5"
                                                        type="number"
                                                        min="0"
                                                        max="5"
                                                        v-model.number="row.stars">
                                            </div>
                                            <!-- End Stars -->
                                        </div>

                                        <div class="row">
                                            <!-- Stars No -->
                                            <div class="form-group col-6">
                                                <label for="inputTextStarsNo">Stars No</label>
                                                <input class="form-control"
                                                        id="inputTextStarsNo"
                                                        type="number"
                                                        min="0"
                                                        v-model.number="row.stars_no">
                                            </div>
                                            <!-- End Stars No -->

                                            <!-- Location -->
                                            <div class="form-group col-6">
                                                <label for="inputTextLocation">Location</label>
                                                <input class="form-control"
                                                        id="inputTextLocation"
                                                        type="text"
                                                        v-model="row.location">
                                            </div>
                                            <!-- End Location -->
                                        </div>

                                        <div class="row">
                                            <!-- Latitude -->
                                            <div class="form-group col-6">
                                                <label for="inputTextLatitude">Latitude</label>
                                                <input class="form-control"
                                                        id="inputTextLatitude"
                                                        type="number"
                                                        step="any"
                                                        v-model="row.latitude">
                                            </div>
                                            <!-- End Latitude -->

                                            <!-- Longitude -->
                                            <div class="form-group col-6">
                                                <label for="inputTextLongitude">Longitude</label>
                                                <input class="form-control"
                                                        id="inputTextLongitude"
                                                        type="number"
                                                        step="any"
                                                        v-model="row.longitude">
                                            </div>
                                            <!-- End Longitude -->
                                        </div>

                                        <div class="row">
                                            <!-- Address -->
                                            <div class="form-group col-6">
                                                <label for="inputTextAddress">Address</label>
                                                <input class="form-control"
                                                        id="inputTextAddress"
                                                        type="text"
                                                        v-model="row.address">
                                            </div>
                                            <!-- End Address -->

                                            <!-- Popular -->
                                            <div class="form-group col-6">
                                                <label for="inputTextPopular">Popular</label>
                                                <select class="form-control"
                                                        id="inputTextPopular"
                                                        v-model="row.popular">
                                                    <option value="">Select Popular</option>
                                                    <option value="popular">Popular</option>
                                                    <option value="topRated">Top rated</option>
                                                    <option value="bestSeller">Best seller</option>
                                                    <option value="bestDeal">Best deal</option>
                                                    <option value="easterOffer">Easter offer</option>
                                                </select>
                                            </div>
                                            <!-- End Popular -->
                                        </div>


                                        <!-- Body -->
                                        <div class="form-group">
                                            <label for="inputEditor1">Body</label>
                                            <editor
                                                id="inputEditor1"
                                                v-model="row.body"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Body -->

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Hotel -->

                    <!-- Card Property Highlights -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabPropertyHighlights" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('PropertyHighlights')"
                                        aria-expanded="false"
                                        aria-controls="collapsePropertyHighlights"
                                        data-toggle="collapse"
                                        data-target="#collapsePropertyHighlights">Property Highlights
                                        <span id="iconTogglePropertyHighlights"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapsePropertyHighlights"
                                    class="collapse show"
                                    aria-labelledby="TabPropertyHighlights"
                                    data-parent="#accordion">
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <editor
                                                id="inputEditorPropertyHighlights"
                                                v-model="row.property_highlights"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Property Highlights -->

                    <!-- Card Breakfast Info -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabBreakfastInfo" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('BreakfastInfo')"
                                        aria-expanded="false"
                                        aria-controls="collapseBreakfastInfo"
                                        data-toggle="collapse"
                                        data-target="#collapseBreakfastInfo">Breakfast Info
                                        <span id="iconToggleBreakfastInfo"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseBreakfastInfo"
                                    class="collapse show"
                                    aria-labelledby="TabBreakfastInfo"
                                    data-parent="#accordion">
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <editor
                                                id="inputEditorBreakfastInfo"
                                                v-model="row.breakfast_info"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Breakfast Info -->

                    <!-- Card Rooms -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabRooms" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Rooms')"
                                        aria-expanded="false"
                                        aria-controls="collapseRooms"
                                        data-toggle="collapse"
                                        data-target="#collapseRooms">Rooms
                                        <span id="iconToggleRooms"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseRooms"
                                    class="collapse"
                                    aria-labelledby="TabRooms"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <div v-for="(room, rIdx) in row.rooms"
                                             :key="'room_'+rIdx"
                                             class="ui-for-div mb-4">

                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeRoom(rIdx)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>

                                            <div class="form-group">
                                                <label>Room Title</label>
                                                <input class="form-control"
                                                       type="text"
                                                       v-model="room.title">
                                            </div>

                                            <div class="form-group">
                                                <label>Description</label>
                                                <editor
                                                    v-model="room.description"
                                                    :api-key="editor.api_key"
                                                    :init="{
                                                        height: 200,
                                                        menubar: editor.menubar,
                                                        plugins: editor.plugins,
                                                        external_plugins: editor.external_plugins,
                                                        toolbar: editor.toolbar
                                                    }"
                                                />
                                            </div>

                                            <div class="row col-12 ui-ml-unset">
                                                <div class="form-group col-6">
                                                    <label>Room Type</label>
                                                    <select class="form-control" v-model="room.room_type">
                                                        <option value="">Select Room Type</option>
                                                        <option v-for="type in roomTypeOptions" :key="type" :value="type">
                                                            {{ type }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group col-6">
                                                    <label>Price</label>
                                                    <input class="form-control"
                                                           type="number"
                                                           min="0"
                                                           step="any"
                                                           v-model.number="room.price">
                                                </div>
                                            </div>

                                            <div class="row col-12 ui-ml-unset">
                                                <div class="form-group col-6">
                                                    <label>Rooms Count</label>
                                                    <input class="form-control"
                                                           type="number"
                                                           min="0"
                                                           v-model.number="room.rooms_count">
                                                </div>
                                                <div class="form-group col-6">
                                                    <label>Meals</label>
                                                    <input class="form-control"
                                                           type="text"
                                                           v-model="room.meals">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>Inclusion</label>
                                                <textarea class="form-control"
                                                          rows="2"
                                                          v-model="room.inclusion"></textarea>
                                            </div>

                                            <div class="mt-3">
                                                <label class="font-bold">Icons</label>

                                                <div v-for="(icon, iIdx) in room.icons"
                                                     :key="'room_'+rIdx+'_icon_'+iIdx"
                                                     class="border p-2 mb-2">
                                                    <div class="row col-12 ui-ml-unset align-items-center mb-2">
                                                        <div class="col-8">
                                                            <img v-if="icon.icon_preview"
                                                                :src="icon.icon_preview"
                                                                class="custom-image">
                                                            <input class="form-control"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    v-on:change="onRoomIconChange($event, rIdx, iIdx)">
                                                        </div>
                                                        <div class="col-4 text-right">
                                                            <button type="button"
                                                                class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                                @click="removeRoomIcon(rIdx, iIdx)">
                                                                <span class="btn-icon ti-close font-bold"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="row col-12 ui-ml-unset">
                                                        <div class="col-4">
                                                            <input class="form-control"
                                                                   type="text"
                                                                   placeholder="Alt"
                                                                   v-model="icon.icon_alt">
                                                        </div>
                                                        <div class="col-4">
                                                            <input class="form-control"
                                                                   type="text"
                                                                   placeholder="Title"
                                                                   v-model="icon.icon_title">
                                                        </div>
                                                        <div class="col-4">
                                                            <input class="form-control"
                                                                   type="text"
                                                                   placeholder="Icon class (e.g. fas fa-wifi)"
                                                                   v-model="icon.icon_class">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row mt-2">
                                                    <button type="button"
                                                        class="btn btn-secondary btn-sm"
                                                        @click="addRoomIcon(rIdx)">
                                                        <span class="ti-plus"></span> Add Icon
                                                    </button>
                                                </div>
                                            </div>

                                            <hr/>
                                        </div>

                                        <div class="row pull-right">
                                            <button type="button"
                                                class="btn btn-dark btn-circle btn-with-icon"
                                                @click="addRoom()">
                                                <span class="btn-icon ti-plus font-bold"></span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Rooms -->

                    <!-- Card Amenities -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabAmenities" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Amenities')"
                                        aria-expanded="false"
                                        aria-controls="collapseAmenities"
                                        data-toggle="collapse"
                                        data-target="#collapseAmenities">Amenities
                                        <span id="iconToggleAmenities"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseAmenities"
                                    class="collapse"
                                    aria-labelledby="TabAmenities"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <div v-for="(amenity, aIdx) in row.amenities"
                                             :key="'amenity_'+aIdx"
                                             class="ui-for-div mb-4">

                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeAmenity(aIdx)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>

                                            <div class="form-group">
                                                <label>Amenity Title</label>
                                                <input class="form-control"
                                                       type="text"
                                                       v-model="amenity.title">
                                            </div>

                                            <div class="form-group">
                                                <label>Description</label>
                                                <editor
                                                    v-model="amenity.description"
                                                    :api-key="editor.api_key"
                                                    :init="{
                                                        height: 200,
                                                        menubar: editor.menubar,
                                                        plugins: editor.plugins,
                                                        external_plugins: editor.external_plugins,
                                                        toolbar: editor.toolbar
                                                    }"
                                                />
                                            </div>

                                            <div class="row col-12 ui-ml-unset">
                                                <div class="col-6">
                                                    <div class="form-group">
                                                        <label>Icon</label>
                                                        <p>
                                                            <img v-if="amenity.icon_preview"
                                                                :src="amenity.icon_preview"
                                                                class="custom-image">
                                                        </p>
                                                        <input class="form-control"
                                                                type="file"
                                                                accept="image/*"
                                                                v-on:change="onAmenityIconChange($event, aIdx)">
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Icon class</label>
                                                        <input class="form-control"
                                                               type="text"
                                                               placeholder="e.g. fas fa-wifi"
                                                               v-model="amenity.icon_class">
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="form-group">
                                                        <label>Popular</label>
                                                        <div class="custom-control custom-checkbox">
                                                            <input :id="'amenityPopular'+aIdx"
                                                                   class="custom-control-input"
                                                                   type="checkbox"
                                                                   v-model="amenity.popular">
                                                            <label class="custom-control-label"
                                                                   :for="'amenityPopular'+aIdx">popular</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr/>
                                        </div>

                                        <div class="row pull-right">
                                            <button type="button"
                                                class="btn btn-dark btn-circle btn-with-icon"
                                                @click="addAmenity()">
                                                <span class="btn-icon ti-plus font-bold"></span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Amenities -->

                    <!-- Card House Rules -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabHouseRules" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('HouseRules')"
                                        aria-expanded="false"
                                        aria-controls="collapseHouseRules"
                                        data-toggle="collapse"
                                        data-target="#collapseHouseRules">House Rules
                                        <span id="iconToggleHouseRules"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseHouseRules"
                                    class="collapse"
                                    aria-labelledby="TabHouseRules"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <div v-for="(houseRule, hIdx) in row.houseRules"
                                             :key="'houseRule_'+hIdx"
                                             class="ui-for-div mb-4">

                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeHouseRule(hIdx)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>

                                            <div class="form-group">
                                                <label>House Rule Title</label>
                                                <input class="form-control"
                                                       type="text"
                                                       v-model="houseRule.title">
                                            </div>

                                            <div class="form-group">
                                                <label>Description</label>
                                                <editor
                                                    v-model="houseRule.description"
                                                    :api-key="editor.api_key"
                                                    :init="{
                                                        height: 200,
                                                        menubar: editor.menubar,
                                                        plugins: editor.plugins,
                                                        external_plugins: editor.external_plugins,
                                                        toolbar: editor.toolbar
                                                    }"
                                                />
                                            </div>

                                            <div class="row col-12 ui-ml-unset">
                                                <div class="col-6 form-group">
                                                    <label>Icon</label>
                                                    <p>
                                                        <img v-if="houseRule.icon_preview"
                                                            :src="houseRule.icon_preview"
                                                            class="custom-image">
                                                    </p>
                                                    <input class="form-control"
                                                            type="file"
                                                            accept="image/*"
                                                            v-on:change="onHouseRuleIconChange($event, hIdx)">
                                                </div>
                                                <div class="col-6 form-group">
                                                    <label>Icon class</label>
                                                    <input class="form-control"
                                                           type="text"
                                                           placeholder="e.g. fas fa-wifi"
                                                           v-model="houseRule.icon_class">
                                                </div>
                                            </div>

                                            <hr/>
                                        </div>

                                        <div class="row pull-right">
                                            <button type="button"
                                                class="btn btn-dark btn-circle btn-with-icon"
                                                @click="addHouseRule()">
                                                <span class="btn-icon ti-plus font-bold"></span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card House Rules -->

                    <!-- Card Galleries -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabGalleries" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Galleries')"
                                        aria-expanded="false"
                                        aria-controls="collapseGalleries"
                                        data-toggle="collapse"
                                        data-target="#collapseGalleries">Galleries
                                        <span id="iconToggleGalleries"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseGalleries"
                                    class="collapse"
                                    aria-labelledby="TabGalleries"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- For Loop -->
                                        <div v-for="i in row.gallery_key"
                                            :key="'gallery'+i"
                                            :id="'galleryFrm_'+i"
                                            class="ui-for-div">

                                            <!-- Remove -->
                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeGalleryOption(i)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End Remove -->

                                            <div class="form-group">
                                                <label :for="'gImageText'+i">Image</label>
                                               <p>
                                                    <img v-if="(row.gallery_image_preview[i])"
                                                        :src="row.gallery_image_preview[i]"
                                                        class="custom-image">
                                                </p>
                                                <input class="form-control"
                                                        :id="'gImageText'+i"
                                                        type="file"
                                                        accept="image/*"
                                                        v-on:change="onGalleryImageChange($event, i)">
                                            </div>

                                            <div class="col-12 row no-padding ui-ml-unset">
                                                <div class="col-6 no-lpadding">
                                                    <div class="form-group">
                                                        <label :for="'gAltText'+i">Image Alt</label>
                                                        <input class="form-control"
                                                                :id="'gAltText'+i"
                                                                type="text"
                                                                v-model="row.gallery_image_alt[i]">
                                                    </div>
                                                </div>

                                                <div class="col-6 no-rpadding">
                                                    <div class="form-group">
                                                        <label :for="'gTitleText'+i">Image Title</label>
                                                        <input class="form-control"
                                                                :id="'gTitleText'+i"
                                                                type="text"
                                                                v-model="row.gallery_image_title[i]">
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button"
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnGalleryFrm()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Galleries -->

                </div>
                 <!-- ******* End Cards ******** -->


                <!-- ******* Navbar ******** -->
                <div class="col-md-4 mb-5">

                    <!-- Nav Language -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavLanguage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Language')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavLanguage"
                                        data-toggle="collapse"
                                        data-target="#collapseNavLanguage">Language
                                        <span id="iconToggleLanguage"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavLanguage"
                                    class="collapse"
                                    aria-labelledby="NavLanguage"
                                    data-parent="#accordionNav">

                                <div class="col-12 pt-3">
                                    <!-- Language -->
                                    <div class="form-group">
                                        <div v-if="languageLoading" class="text-center">
                                            <span class="spinner-grow spinner-grow-sm mr-1"
                                                role="status"
                                                aria-hidden="true">
                                            </span>
                                        </div>
                                        <select class="form-control custom-select"
                                                v-if="!languageLoading"
                                                v-model="row.language_id">
                                                <option value="">Select Language</option>
                                                <option v-for="(language, index) in languages"
                                                        :key="index"
                                                        :value="language.id">
                                                        {{ language.name }}
                                                </option>
                                        </select>
                                    </div>
                                    <!-- End Language -->
                                </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Language -->

                    <!-- Nav Destination -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavDestination" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Destination')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavDestination"
                                        data-toggle="collapse"
                                        data-target="#collapseNavDestination">Destination
                                        <span id="iconToggleDestination"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavDestination"
                                    class="collapse"
                                    aria-labelledby="NavDestination"
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="destinationLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                    v-if="!destinationLoading"
                                                    v-model="row.destination_id">
                                                    <option value="">Select Destination</option>
                                                    <optgroup v-for="(region, index) in destinations"
                                                            :key="index"
                                                            :label="region.title">
                                                        <option v-for="(destination,idx) in region.destinations"
                                                            :key="idx"
                                                            :value="destination.id">
                                                            {{ destination.title }}
                                                        </option>
                                                    </optgroup>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Destination -->

                    <!-- Nav Category -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavCategory" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Category')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavCategory"
                                        data-toggle="collapse"
                                        data-target="#collapseNavCategory">Category
                                        <span id="iconToggleCategory"
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavCategory"
                                    class="collapse"
                                    aria-labelledby="NavCategory"
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="categoryLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                v-if="!categoryLoading"
                                                v-model="row.category_id">
                                                <option value="">Select Category</option>
                                                <option v-for="(category, index) in categories"
                                                        :key="index"
                                                        :value="category.id">
                                                        {{ category.title }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Category -->

                    <!-- Nav Multiple Tags -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleTags" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('MultipleTags')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavMultipleTags"
                                        data-toggle="collapse"
                                        data-target="#collapseNavMultipleTags">Multiple Tags
                                        <span id="iconToggleMultipleTags"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleTags"
                                    class="collapse"
                                    aria-labelledby="NavMultipleTags"
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="tagsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!tagsLoading"
                                                    id="multiselectTags"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.tagsValues"
                                                    :options="tagsOptions"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :hide-selected="true"
                                                    :preserve-search="true"
                                                    :taggable="false"
                                                    placeholder="Type to search tags"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Tags -->

                    <!-- Nav Multiple Icons -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleIcons" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('MultipleIcons')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavMultipleIcons"
                                        data-toggle="collapse"
                                        data-target="#collapseNavMultipleIcons">Multiple Icons
                                        <span id="iconToggleMultipleIcons"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleIcons"
                                    class="collapse"
                                    aria-labelledby="NavMultipleIcons"
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="iconsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!iconsLoading"
                                                    id="multiselectIcons"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.iconsValues"
                                                    :options="iconsOptions"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :hide-selected="true"
                                                    :preserve-search="true"
                                                    :taggable="false"
                                                    placeholder="Type to search icons"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Icons -->

                    <!-- Linked FAQs -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavFaqs" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Faqs')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavFaqs"
                                        data-toggle="collapse"
                                        data-target="#collapseNavFaqs">Linked FAQs
                                        <span id="iconToggleFaqs"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavFaqs"
                                    class="collapse"
                                    aria-labelledby="NavFaqs"
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        <p class="text-muted small">Order follows selection order in the list.</p>
                                        <div class="form-group">
                                            <div v-if="faqsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!faqsLoading"
                                                id="multiselect-faqs-hotels"
                                                v-model="row.faqsValues"
                                                :options="faqsOptions"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :hide-selected="true"
                                                :preserve-search="true"
                                                :taggable="false"
                                                label="title"
                                                track-by="id"
                                                placeholder="Search and select FAQs"
                                                :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Linked FAQs -->

                    <!-- Nav Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Image')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavImage"
                                        data-toggle="collapse"
                                        data-target="#collapseNavImage">Featued Image
                                        <span id="iconToggleImage"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavImage"
                                        class="collapse"
                                        aria-labelledby="NavImage"
                                        data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img v-if="row.preview"
                                                :src="row.preview"
                                                class="mb-2 custom-image">
                                            <input type="file"
                                                class="form-control"
                                                ref="myDropify"
                                                v-on:change="onImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- End Image -->

                                        <!-- Image alt -->
                                        <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text"
                                                    class="form-control"
                                                    v-model="row.image_alt">
                                        </div>
                                        <!-- End Image alt -->

                                        <!-- Image title -->
                                        <div class="form-group">
                                            <label>Image title</label>
                                            <input type="text"
                                                class="form-control"
                                                v-model="row.image_title">
                                        </div>
                                        <!-- End Image title -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Image -->

                    <!-- Nav Meta -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMeta" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Meta')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavMeta"
                                        data-toggle="collapse"
                                        data-target="#collapseNavMeta">Meta / SEO
                                        <span id="iconToggleMeta"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMeta"
                                        class="collapse"
                                        aria-labelledby="NavMeta"
                                        data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <!-- Meta Title -->
                                        <div class="form-group">
                                            <label>Meta Title
                                                <span class="text-muted" v-if="row.meta_title" v-text="(row.meta_title.length)"></span>
                                            </label>
                                            <input type="text"
                                                class="form-control"
                                                v-model="row.meta_title">
                                        </div>
                                        <!-- End Meta Title -->

                                        <!-- Meta Keywords -->
                                        <div class="form-group">
                                            <label>Meta Keywords
                                                <span class="text-muted" v-if="row.meta_keywords" v-text="(row.meta_keywords.length)"></span>
                                            </label>
                                            <input type="text"
                                                class="form-control"
                                                v-model="row.meta_keywords">
                                        </div>
                                        <!-- End Meta Keywords -->

                                        <!-- Meta Description -->
                                        <div class="form-group">
                                            <label>Meta Description
                                                <span class="text-muted" v-if="row.meta_description" v-text="(row.meta_description.length)"></span>
                                            </label>
                                            <textarea
                                                class="form-control"
                                                rows="3"
                                                v-model="row.meta_description"></textarea>
                                        </div>
                                        <!-- End Meta Description -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Meta -->

                    <!-- Nav Status -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavStatus" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Status')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavStatus"
                                        data-toggle="collapse"
                                        data-target="#collapseNavStatus">Status & Visibility
                                        <span id="iconToggleStatus"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavStatus"
                                    class="collapse"
                                    aria-labelledby="NavStatus"
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <!-- Status -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox"
                                                    class="custom-control-input"
                                                    id="customSwitch1"
                                                    :checked="row.status"
                                                    @click="onStatus">
                                                <label class="custom-control-label"
                                                    for="customSwitch1"
                                                    v-html="(row.status) ? 'Active' : 'Inactive'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Status -->

                                        <!-- View in home -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox"
                                                        class="custom-control-input"
                                                        id="customSwitch2"
                                                        :checked="row.view_in_home"
                                                        @click="onViewInHome">
                                                    <label class="custom-control-label"
                                                        for="customSwitch2"
                                                        v-html="(row.view_in_home)
                                                            ? 'Show In Home'
                                                            : 'Hide In Home'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in home -->

                                            <!-- View in menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox"
                                                        class="custom-control-input"
                                                        id="customSwitch5"
                                                        :checked="row.view_in_menu"
                                                        @click="onViewInMenu">
                                                    <label class="custom-control-label"
                                                        for="customSwitch5"
                                                        v-html="(row.view_in_menu)
                                                            ? 'Show In Menu'
                                                            : 'Hide In Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in menu -->

                                            <!-- Menu Order -->
                                            <div class="no-rpadding">
                                                <div class="form-group">
                                                    <input class="form-control"
                                                            v-bind:style="{display: orderDisplay}"
                                                            placeholder="Order In Menu"
                                                            id="inputText8"
                                                            type="number"
                                                            min="0"
                                                            v-model.number="row.menu_order">
                                                </div>
                                            </div>
                                            <!-- End Menu Order -->

                                            <!-- View in sub menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox"
                                                        class="custom-control-input"
                                                        id="customSwitch6"
                                                        :checked="row.view_in_sub_menu"
                                                        @click="onViewInSubMenu">
                                                    <label class="custom-control-label"
                                                        for="customSwitch6"
                                                        v-html="(row.view_in_sub_menu)
                                                            ? 'Show In Sub Menu'
                                                            : 'Hide In Sub Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in sub menu -->
                                            <!--  Menu -->
                                            <div class="col-12 pt-3">
                                                <div class="form-group">
                                                    <div v-if="menuLoading" class="text-center">
                                                        <span class="spinner-grow spinner-grow-sm mr-1"
                                                            role="status"
                                                            aria-hidden="true">
                                                        </span>
                                                    </div>
                                                    <select v-bind:style="{display: inputDisplay}" class="form-control custom-select"
                                                        v-if="!menuLoading"
                                                        v-model="row.menu_id">
                                                        <option value="">Select Menu</option>
                                                        <option v-for="(menu, index) in menus"
                                                                :key="index"

                                                                :value="menu.id">
                                                                {{ menu.title }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <!--  End Menu -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Status -->

                </div>
                <!-- ******* End Navbar ******** -->


                    </div>
                </div>
                <!-- End Content -->


                    <!-- Button -->
                    <div class="col-md-12 row">
                        <div class="form-group mr-2">
                            <button class="btn btn-primary" :disabled="btnLoading">
                                <span v-if="btnLoading">
                                    <span class="spinner-grow spinner-grow-sm mr-1"
                                        role="status" aria-hidden="true">
                                    </span>Loading...
                                </span>
                                <span v-if="!btnLoading" class="ti-check-box"></span>
                                <span v-if="!btnLoading"> Create Hotel</span>
                            </button>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-danger"
                                :disabled="btnLoading"
                                @click="cancel">
                                <span class="ti-close"></span>
                                <span> Cancel </span>
                            </button>
                        </div>
                    </div>
                    <!-- End Button -->


                </form>
            </div>


                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->

    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import Multiselect from 'vue-multiselect';
    import iziToast from 'izitoast';

    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Editor,
            Footer,
            Multiselect
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // row
                    link: '',
                    stars: '',
                    sort: 0,
                    title: '',
                    slug: '',
                    body: '',

                    // location & ratings
                    latitude: '',
                    longitude: '',
                    stars_no: '',
                    location: '',
                    popular: '',
                    address: '',
                    property_highlights: '',
                    breakfast_info: '',

                    // relations
                    destination_id: '',
                    category_id: '',
                    tagsValues: [],
                    iconsValues: [],
                    faqsValues: [],

                    // meta
                    meta_title: '',
                    meta_keywords: '',
                    meta_description: '',

                    // repeatable sections
                    rooms: [],
                    amenities: [],
                    houseRules: [],

                    // galleries
                    galleries: [],
                    gallery_key: 0,
                    gallery_image_preview: [],
                    gallery_image_base64: [],
                    gallery_image_alt: [],
                    gallery_image_title: [],

                    // image
                    preview: '',
                    image_base: '',
                    image_alt: '',
                    image_title: '',

                    // status & visibility
                    status: 1,
                    view_in_home: 0,
                    view_in_menu: 0,
                    view_in_sub_menu: 0,
                    menu_id: '',
                    menu_order: '',
                    //language
                    language_id:'',
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },

                pgLoading: false,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'hotels',

                // language
                languages: [],
                languageLoading: true,

                // destination & category
                destinations: [],
                destinationLoading: true,
                categories: [],
                categoryLoading: true,

                // tags & icons & faqs
                tagsOptions: [],
                tagsLoading: true,
                iconsOptions: [],
                iconsLoading: true,
                faqsOptions: [],
                faqsLoading: true,

                // room type options
                roomTypeOptions: ['Single', 'Double', 'Twin', 'Triple', 'Suite', 'Family', 'Deluxe'],

                // menu
                menus: [],
                menuLoading: true,
                inputDisplay: 'none',
                orderDisplay: 'none',
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchLanguages();
            this.fetchDestination();
            this.fetchMultipleTags();
            this.fetchFaqs();

        },
        methods: {

            // fetch Language
            fetchLanguages(){
                this.languageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/languages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.languageLoading = false;
                        this.languages = res.data.rows;
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // fetchDestination
            fetchDestination() {
                this.destinationLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/regions',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.destinationLoading = false;
                    this.destinations = res.data.rows;

                    this.fetchCategories(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchCategories
            fetchCategories() {
                this.categoryLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/categories',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.categoryLoading = false;
                    this.categories = res.data.rows;
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultipleTags
            fetchMultipleTags(){
                this.tagsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/tags',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.tagsLoading = false;
                    this.tagsOptions = res.data.tags;

                    this.fetchMultipleIcons(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultipleIcons
            fetchMultipleIcons(){
                this.iconsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/icons',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.iconsLoading = false;
                    this.iconsOptions = res.data.icons;
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchFaqs
            fetchFaqs(){
                this.faqsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/faqs',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 1000,
                    },
                };
                this.axios(options)
                    .then(res => {
                        this.faqsOptions = res.data.rows || [];
                    })
                    .catch(() => { this.faqsOptions = []; })
                    .finally(() => { this.faqsLoading = false; });
            },

            // Rooms
            addRoom() {
                this.row.rooms.push({
                    title: '', description: '', price: '', room_type: '',
                    inclusion: '', rooms_count: '', meals: '', sort: this.row.rooms.length,
                    icons: [],
                });
            },
            removeRoom(idx) {
                this.row.rooms.splice(idx, 1);
            },
            addRoomIcon(roomIdx) {
                this.row.rooms[roomIdx].icons.push({ icon_preview: '', icon_base64: '', icon_alt: '', icon_title: '', icon_class: '' });
            },
            removeRoomIcon(roomIdx, iconIdx) {
                this.row.rooms[roomIdx].icons.splice(iconIdx, 1);
            },
            onRoomIconChange(e, roomIdx, iconIdx) {
                const file = e.target.files[0];
                const icon = this.row.rooms[roomIdx].icons[iconIdx];
                icon.icon_preview = URL.createObjectURL(file);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ev => {
                    icon.icon_base64 = ev.target.result;
                };
            },
            serializeRooms(rooms) {
                return (rooms || []).map((room, index) => ({
                    ...room,
                    sort: room && room.sort != null ? room.sort : index,
                    icons: (room.icons || []).map(icon => ({
                        icon_base64: icon.icon_base64,
                        icon_alt: icon.icon_alt,
                        icon_title: icon.icon_title,
                        icon_class: icon.icon_class,
                    })),
                }));
            },

            // Amenities
            addAmenity() {
                this.row.amenities.push({
                    title: '', description: '', popular: false, sort: this.row.amenities.length,
                    icon_preview: '', icon_base64: '', icon_alt: '', icon_title: '', icon_class: '',
                });
            },
            removeAmenity(idx) {
                this.row.amenities.splice(idx, 1);
            },
            onAmenityIconChange(e, idx) {
                const file = e.target.files[0];
                const amenity = this.row.amenities[idx];
                amenity.icon_preview = URL.createObjectURL(file);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ev => {
                    amenity.icon_base64 = ev.target.result;
                };
            },
            serializeAmenities(amenities) {
                return (amenities || []).map((amenity, index) => ({
                    ...amenity,
                    sort: amenity && amenity.sort != null ? amenity.sort : index,
                    popular: amenity.popular ? 1 : 0,
                }));
            },

            // House Rules
            addHouseRule() {
                this.row.houseRules.push({
                    title: '', description: '', sort: this.row.houseRules.length,
                    icon_preview: '', icon_base64: '', icon_alt: '', icon_title: '', icon_class: '',
                });
            },
            removeHouseRule(idx) {
                this.row.houseRules.splice(idx, 1);
            },
            onHouseRuleIconChange(e, idx) {
                const file = e.target.files[0];
                const houseRule = this.row.houseRules[idx];
                houseRule.icon_preview = URL.createObjectURL(file);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ev => {
                    houseRule.icon_base64 = ev.target.result;
                };
            },
            serializeHouseRules(houseRules) {
                return (houseRules || []).map((houseRule, index) => ({
                    ...houseRule,
                    sort: houseRule && houseRule.sort != null ? houseRule.sort : index,
                }));
            },

            // Galleries
            opnGalleryFrm() {
                this.row.gallery_key++;
            },
            removeGalleryOption(i) {
                document.querySelector('#galleryFrm_'+i).remove();
                this.row.gallery_image_preview[i] = '';
                this.row.gallery_image_base64[i] = '';
                this.row.gallery_image_alt[i] = '';
                this.row.gallery_image_title[i] = '';
            },
            onGalleryImageChange(e, i){
                const file = e.target.files[0];
                this.row.gallery_image_preview[i] = URL.createObjectURL(file);
                this.createBase64Gallery(file, i);
            },
            createBase64Gallery(fileObject, i){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.gallery_image_base64[i] = e.target.result;
                };
            },

            // Add New
            addNew(){
                if(this.tenant_id == 0) {

                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {

                    if (this.row.status == false) {
                        this.row.status = 0;
                    } else {
                        this.row.status = 1;
                    }
                    if (this.row.view_in_home == false) {
                        this.row.view_in_home = 0;
                    } else {
                        this.row.view_in_home = 1;
                    }

                    if (this.row.view_in_menu == false) {
                        this.row.view_in_menu = 0;
                    } else {
                        this.row.view_in_menu = 1;
                    }

                    if (this.row.view_in_sub_menu == false) {
                        this.row.view_in_sub_menu = 0;
                    } else {
                        this.row.view_in_sub_menu = 1;
                    }

                    // galleries
                    for( let i = 1; i < this.row.gallery_image_base64.length; i++ ) {
                        if (this.row.gallery_image_base64[i]) {
                            this.row.galleries[i] = {
                                'gallery_image_base64' : this.row.gallery_image_base64[i],
                                'gallery_image_alt' : this.row.gallery_image_alt[i],
                                'gallery_image_title' : this.row.gallery_image_title[i]
                            }
                        }
                    }

                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };
                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};
                    const options = {
                        url: window.baseURL+'/'+this.refs,
                        method: 'POST',
                        data: {
                            tenant_id: this.tenant_id,
                            // row
                            link: this.row.link,
                            stars: this.row.stars,
                            sort: this.row.sort,
                            title: this.row.title,
                            slug: this.row.slug,
                            body: this.row.body,

                            // location & ratings
                            latitude: this.row.latitude,
                            longitude: this.row.longitude,
                            stars_no: this.row.stars_no,
                            location: this.row.location,
                            popular: this.row.popular,
                            address: this.row.address,
                            property_highlights: this.row.property_highlights,
                            breakfast_info: this.row.breakfast_info,

                            // relations
                            destination_id: this.row.destination_id,
                            category_id: this.row.category_id,
                            tags: this.row.tagsValues,
                            icons: this.row.iconsValues,
                            faqs: (this.row.faqsValues || []).map(f => f.id),

                            // meta
                            meta_title: this.row.meta_title,
                            meta_keywords: this.row.meta_keywords,
                            meta_description: this.row.meta_description,

                            // repeatable sections
                            rooms: this.serializeRooms(this.row.rooms),
                            amenities: this.serializeAmenities(this.row.amenities),
                            house_rules: this.serializeHouseRules(this.row.houseRules),

                            // galleries
                            galleries: this.row.galleries,

                            // image
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // status & visiblity
                            status: this.row.status,
                            view_in_home: this.row.view_in_home,
                            view_in_menu: this.row.view_in_menu,
                            menu_order: this.row.menu_order,
                            view_in_sub_menu: this.row.view_in_sub_menu,
                            menu_id: this.row.menu_id,
                            //language
                            language_id: this.row.language_id,
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Added Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: (err.response) ? err.response.data.message : ''+err
                                });
                            }
                        })
                        .finally(() => {})
                }
            },

            // Title
            onTitleChange() {
                this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str){
                if(!str) {
                   let str = this.row.slug;
                   this.row.slug = str.replace(/\s+/g, '-');
                } else {
                    this.row.slug = str.replace(/\s+/g, '-');
                }
            },

            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },

            // view in home
            onViewInHome(){
                if(this.row.view_in_home)
                    this.row.view_in_home = 0;
                else
                    this.row.view_in_home = 1;
            },
            // view in menu
            onViewInMenu(){
                if(this.row.view_in_menu) {
                    this.row.view_in_menu = 0;
                    this.orderDisplay = 'none';
                }
                else {
                    this.row.view_in_menu = 1;
                    this.orderDisplay = 'block';
                }
            },

            // view in sub menu
            onViewInSubMenu(){
                if(this.row.view_in_sub_menu) {
                    this.row.view_in_sub_menu = 0;
                    this.inputDisplay = 'none';
                }
                else {
                    this.row.view_in_sub_menu = 1;
                    this.inputDisplay = 'block';
                }
            },

            // fetchMenus
            fetchMenus() {
                this.menuLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/menus',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.menuLoading = false;
                    this.menus = res.data.rows;
                })
                .catch(() => {})
                .finally(() => {});
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // toggleCollapse
            collapseToggle(div) {
                if (div == 'Status') {
                    this.fetchMenus();
                }
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
